export default __webpack_public_path__ + "static/media/itch-logo-black.3cd604e9.svg";